const getImpersonated = (user) => {
    if (user.impersonate) {
        return user.impersonate
    }
    const fetchFSValue = JSON.parse(window.localStorage.getItem('FS-Impersonate'))
    return !!fetchFSValue;
}

export { getImpersonated }